import '../../styles/bitacora.style.css'
import {useDispatch, useSelector} from 'react-redux'
import { State } from '../../../../reducers'
import BasicCardDocumentos from '../DatosDeCierre/BasicCardDocumentos'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'

import DownloadIcon from '../../../../media/felsv/Download.svg';
import EditIcon from '../../../../media/felsv/PenEdit.svg'
import OpenEyeIcon from '../../../../media/felsv/Open_Eye.svg';
import DeleteIcon from '../../../../media/felsv/DarkRecycleDelete.svg';

import { deleteLibroCompras, editLibroCompras, getLibroComprasDetallado } from '../../../../actions/libros/libro-compras.actions'
import { useHistory } from 'react-router'
import { useEffect, useState } from 'react'
import ModalCargarFileCompras from './ModalCargarFileCompras'
import { Pagination } from '../../../../components/Pagination'
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'
import { ventasOpenModalFormatos } from '../../../../actions/libros/libros-ventas.actions'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import ModalEditLibro from './ModalEditLibro'

import { LibroComprasEditar } from '../../../../interfaces/libros/compras.interface'

const TableLibrosCompras = () => {
  const {comprasDataLibros} = useSelector((state: State) => state.libros);

  const [modalCargarFile, setModalCargarFile] = useState<boolean> (false);
  const [modalConfirmDelete, setModalConfirmDelete] = useState<boolean> (false);
  const [modalEditLibro, setModalEditLibro] = useState<boolean> (false);

  const [currentItems, setCurrentItems] = useState<Array<any>>([]);
  const [sortedArray, setSortedArray] = useState<Array<any>>([]);
  const [selectedLibro, setSelectedLibro] = useState<any>(null);

  const dispatch = useDispatch();
  const history = useHistory();
  
  useEffect(() => {
    setCurrentItems(comprasDataLibros);
  }, [comprasDataLibros]);

  useEffect(() => {
    setSortedArray(currentItems);
  }, [currentItems]);

  const handleGenerarLibro = async (item: any) => {
    if (await dispatch(getLibroComprasDetallado(item.idlibrocompras, true, item))) {
    }
  }

  const handleVerLibro = async (item: any) => {
    if (await dispatch(getLibroComprasDetallado(item.idlibrocompras, false, item))) {
      history.push('/mas-opciones/libro-compras-detalle');
    }
  }

  const handlePrevisualizarCargaLibro = () => {
    history.push('/mas-opciones/libro-compras-nuevo');
  }

  const handleDownloadPlantillas = () => {
    dispatch(ventasOpenModalFormatos(true));
  }

  const handleConfirmEliminarLibro = (item: any) => {
    setSelectedLibro(item);
    setModalConfirmDelete(true);
  }

  const handleOpenModalEditLibro = (item: any) => {
    setSelectedLibro(item);
    setModalEditLibro(true);
  }

  const handleEliminarLibro = async () => {
    if (await dispatch(deleteLibroCompras(selectedLibro?.idlibrocompras))) {
      setModalConfirmDelete(false);
    } 
  }

  const handleEditarLibro = async (editedLibro: LibroComprasEditar) => {
    editedLibro.idlibrocompras = selectedLibro?.idlibrocompras;
    if (await dispatch(editLibroCompras(editedLibro))) {
      setModalEditLibro(false);
    } 
  }

  return (
    <div className="w-layout-layout bill-section wf-layout-layout">
      {
        modalCargarFile && <ModalCargarFileCompras onAccept={handlePrevisualizarCargaLibro} onClose={() => setModalCargarFile(false)} />
      }
      {
        modalEditLibro && <ModalEditLibro selectedLibro={selectedLibro} onAccept={handleEditarLibro} onClose={() => setModalEditLibro(false)} />
      }
      {
        modalConfirmDelete && 
          <ModalConfirm 
            title={'Eliminar libro'} 
            detail={'Estás a punto de eliminar el libro de compras. ¿Deseas continuar?'}
            closeModalConfirm={() => setModalConfirmDelete(false)} 
            actionConfirm={() => handleEliminarLibro()} 
          />
      }
      <BasicCardDocumentos 
        style={{boxShadow: 'none', padding: '0'}} 
        title="Libros generados" 
        size="l"
      >
        <div className="tab-plane">
          <div className="table-facturacion-resp">
            <table className="table-main-responsive responsive-table-main td-left table-pointer">
              <thead>
                <tr>
                  <td>Nombre <FilterButton keyName='descripcion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Fecha Declaración <FilterButton keyName='fechadeclaracion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Fecha Generación <FilterButton keyName='fechacreacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Acciones</td>
                </tr>
              </thead>
              <tbody>
                {
                  sortedArray?.length > 0 ? 
                  (
                    sortedArray?.map((item: any) => (
                      <tr key={item.fechacreacion}>
                        <td data-label="Descripción">{item.descripcion}</td>
                        <td data-label="Fecha Declaración">{item.fechadeclaracion}</td>
                        <td data-label="Fecha Generación">{item.fechacreacion}</td>
                        <td data-label='Acciones' className='table-td'>
                          <Tooltip content='Editar Nombre'>
                            <button className='table-action' onClick={(e) => handleOpenModalEditLibro(item)}>
                              <img src={EditIcon} alt='Editar Nombre' className='table-img-action' />
                            </button>
                          </Tooltip>
                          <Tooltip content='Ver Libro'>
                            <button className='table-action' onClick={(e) => handleVerLibro(item)}>
                              <img src={OpenEyeIcon} alt='Ver Libro' className='table-img-action' />
                            </button>
                          </Tooltip>
                          <Tooltip content='Descargar Libro'>
                            <button className='table-action' onClick={(e) => handleGenerarLibro(item)}>
                              <img src={DownloadIcon} alt='Descargar Libro' className='table-img-action' />
                            </button>
                          </Tooltip>
                          <Tooltip content='Eliminar Libro'>
                            <button className='table-action' onClick={(e) => handleConfirmEliminarLibro(item)}>
                              <img src={DeleteIcon} alt='Eliminar Libro' className='table-img-action' />
                            </button>
                          </Tooltip>
                        </td>
                      </tr>
                    )) 
                  )
                  : (
                    <tr>
                      <td colSpan={4} style={{ textAlign: 'center', padding: '16px' }}>
                        No hay datos registrados
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </table>
            <Pagination
              data={comprasDataLibros}
              state={(items: Array<any>) => setCurrentItems(items)}
              items={12}
            />
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginTop: '16px'}}>
            <button className="button w-auto transparent" onClick={handleDownloadPlantillas}>Descargar plantillas</button>
            <button className="button w-auto" onClick={() => setModalCargarFile(true)}>Cargar plantilla</button>
          </div>
        </div>
      </BasicCardDocumentos>
    </div>
  )
}

export default TableLibrosCompras
